export default __webpack_public_path__ + "static/media/1998.dc649571.png";